import { useEffect, useState } from 'react';
import { getAccessToken, getUser } from '../../stores/auth/services';
import ConfirmModal from '../SharedComponents/ConfirmModal/ConfirmModal';
import { getCurrentRoute } from '@/navigations/RootNavigation';

const noTherapistText =
  'Ihr Tablet ist noch nicht mit einem Therapeut:innen–Account verbunden. Bitte geben Sie diesen Code an Ihre:n Therapeut:in.';

const noSetsText =
  'Ihr:e Therapeut:in hat noch kein Übungsset für Sie ausgewählt';

export function TherapistNoticeModal({
  noTherapistNotice,
  syncPatientSettings,
  setNoTherapistNotice,
  serverLogoutUser,
  localLogoutUser,
}) {
  const [code, setCode] = useState('');
  const currentRoute = getCurrentRoute().name;
  const isHomeRoute = currentRoute === 'Home';

  const isNoSets = noTherapistNotice?.includes('Übungsset');

  useEffect(() => {
    (async () => {
      if (isNoSets) {
        return;
      }

      if (!isHomeRoute) {
        return;
      }

      const user = await getUser();
      setCode(user.code);
    })();
  }, [isNoSets, currentRoute]);

  return (
    <ConfirmModal
      headerText={'Download fehlgeschlagen'}
      contentText={isNoSets ? noSetsText : noTherapistText}
      hasEmail={!isNoSets}
      emailText={code}
      isVisible={Boolean(noTherapistNotice) && isHomeRoute}
      confirmText={'wiederholen'}
      confirmAction={async () => {
        await syncPatientSettings();
      }}
      cancelText={'abmelden'}
      cancelAction={async () => {
        setNoTherapistNotice(false);
        await serverLogoutUser({ jwt: await getAccessToken() });
        await localLogoutUser();
      }}
      emailCanBeCopied={!isNoSets}
    />
  );
}
